import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import { OrganizationHolidayForm } from './OrganizationHolidayForm'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'

const HolidayDeleteButton = ({ holiday, reload }) => {
  const dispatch = useDispatch()
  const OnDeleteConfirm = function () {
    new rest.RestService(holiday.url).makeDeleteRequest().then(
      (response) => {
        dispatch(
          showSuccessToast(
            `Deleted Holiday ${holiday.date}`,
            `Deleted Holiday ${holiday.date}`
          )
        )
        reload()
      },
      (errors) => {
        dispatch(
          showErrorToast(
            `Could not delete organization ${holiday.date}`,
            errors.response.data
          )
        )
      }
    )
  }
  return (
    <components.Confirm
      onConfirm={OnDeleteConfirm}
      body="Are you sure you want to remove this holiday?"
      confirmText="Confirm Delete holiday"
      confirmBSStyle="danger"
      title="Deleting holiday"
    >
      <ReactBootstrap.Button size="sm" variant="dark">
        {components.ICONS.DELETE}
      </ReactBootstrap.Button>
    </components.Confirm>
  )
}

export const HolidaysGrid = ({
  loading,
  organization,
  apiResponse,
  onChange,
}) => {
  const dispatch = useDispatch()
  const getActionItems = (cell, row) => {
    return <HolidayDeleteButton reload={onChange} holiday={row} />
  }
  const columns = [
    {
      dataField: 'date',
      text: 'Date',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'description',
      searchFieldKey: 'description',
      text: 'Description',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: '',
      text: '',
      formatter: getActionItems,
    },
  ]
  const addHoliday = (values) => {
    var day = (values.date.getDate() < 10 ? '0' : '') + values.date.getDate() //Date of the month: 2 in our example
    var month = values.date.getMonth() + 1 //Month of the Year: 0-based index, so 1 in our example
    var year = values.date.getFullYear() //Year: 2013

    const payLoad = {
      ...values,
      date: `${year}-${month}-${day}`,
      organization: organization.url,
    }
    new rest.OrganizationService(`${organization.url}add_holiday`)
      .makePostRequest(payLoad)
      .then((response) => {
        dispatch(
          showSuccessToast(
            `Added Holiday ${response.date}`,
            `Holiday for ${response.date} has been added to the system.`
          )
        )
        onChange()
      })
      .catch((errors) => {
        dispatch(showErrorToast(`Could not add Holiday`, errors.response.data))
      })
  }

  return loading ? (
    <components.Loading />
  ) : (
    <>
      <div className="mb-5 text-end">
        <components.Slider
          title={components.ICONS.PLUS}
          header={
            <span>
              <span className="pr-2">{components.ICONS.PLUS}</span>
              Adding Holidays
            </span>
          }
        >
          <OrganizationHolidayForm onSubmit={addHoliday} />
        </components.Slider>
      </div>
      <components.DataGrid
        data={apiResponse || []}
        sizePerPage={10}
        page={1}
        columns={columns}
        count={apiResponse ? apiResponse.length : 0}
      />
    </>
  )
}
